import ClassNames from 'classnames'
import React from 'react'
import {
  Grid,
  Image,
  Section,
  Text
} from './../../../components'
import {
  VARIABLES
} from './../../../themes'
import {
  AccordionControlBase
} from './../../base'
import { AccordionControlWrapper } from './styled'

class AccordionControlButton extends React.PureComponent {
  render() {
    const {
      className,
      active,
      onClick,
      name,
      icon,
      collapsible
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
      'accordion__button__item',
      { 'is-active': active },
      { 'is-collapsible': collapsible }
    )

    return (
      <div className={classes}>
        <Section onClick={onClick}>
          <Grid gutter='5'>
            <Grid.Column>
              <Section
                width='45'
                justify='center'
              >
                <Image ui={icon} />
              </Section>
            </Grid.Column>
            <Grid.Column flex="1">
              <Text
                regular16={!active}
                bold16={active}
                color={VARIABLES.COLORS.WHITE}
              >
                {name}
              </Text>
            </Grid.Column>
          </Grid>
        </Section>
      </div>
    )
  }

  static defaultProps = {
  }

  static propTypes = {
  }
}

class AccordionControlButtonSubMenu extends React.PureComponent {
  render() {
    const {
      className,
      active,
      onClick,
      name
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
      'accordion__buttonsubmenu',
      { 'is-active': active }
    )

    return (
      <div
        className={classes}
        onClick={onClick}
        onKeyDown={() => { }}
        role='button'
        tabIndex={0}
      >
        <Grid>
          <Grid.Column flex='1'>
            <Section
              paddingLeft='56'
              paddingVertical='11'
            >
              <Text
                regular14
                singleLine
                color={VARIABLES.COLORS.WHITE}
              >
                {name}
              </Text>
            </Section>
          </Grid.Column>
          <Grid.Column flex='none'>
            <Section
              className='accordion__buttonsubmenu__arrow'
              width='34'
              paddingTop='10'
              paddingLeft='10'
              paddingRight='15'
            >
              <Image ui='iconArrowSideMenu' />
            </Section>
          </Grid.Column>
        </Grid>
      </div>
    )
  }

  static defaultProps = {
  }

  static propTypes = {
  }
}

class AccordionControlButtonHelp extends React.PureComponent {
  render() {
    const {
      className,
      name
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
      'accordion__buttonhelp'
    )

    return (
      <div className={classes}>
        <Text
          bold14
          color={VARIABLES.COLORS.PRIMARY_2}
        >
          {name}
        </Text>
      </div>
    )
  }

  static defaultProps = {
  }

  static propTypes = {
  }
}

class AccordionControlButtonOutline extends React.PureComponent {
  render() {
    const {
      className,
      name
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
      'accordion__buttonoutline'
    )

    return (
      <div className={classes}>
        <Text
          bold12
          color={VARIABLES.COLORS.BLACK}
        >
          {name}
        </Text>
      </div>
    )
  }

  static defaultProps = {
  }

  static propTypes = {
  }
}

export class AccordionControl extends React.PureComponent {
  render() {
    const {
      children,
      className,
      menuSidebar,
      help,
      dropdownNotification,
      outline,
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
      { 'is-menu-sidebar': menuSidebar },
      { 'is-help': help },
      { 'is-dropdown-notification': dropdownNotification },
      { 'is-outline': outline },
    )

    return (
      <AccordionControlWrapper
        {...this.props}
        className={classes}
      >
        {children}
      </AccordionControlWrapper>
    )
  }

  static Button = AccordionControlButton
  static ButtonSubMenu = AccordionControlButtonSubMenu
  static ButtonHelp = AccordionControlButtonHelp
  static ButtonOutline = AccordionControlButtonOutline

  static defaultProps = {
  }

  static propTypes = {
  }
}
